export const LIMIT = 10;

export enum InfiniteScrollKey {
  DEFAULT = "default",
  INCOME = "income",
}

export const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};
